import React from "react";

import { useGetCareersMedia } from "../../../../../hooks/misc";

import ResultGaugeChart from "../../../../reusables/results/ResultGaugeChart";
import { PDFViewer } from "../../../../wrappers/PDFViewer";
import Loader from "../../../../reusables/Loader";

interface IScanScoreCardProps {
    studentId: number;
    mediaId: number;
    score: number;
}

const ScanScoreCard = (props: IScanScoreCardProps) => {
    const { studentId, mediaId, score } = props;

    const { data: media, isLoading: isMediaLoading } = useGetCareersMedia(studentId, mediaId);

    if (isMediaLoading) {
        return <Loader type={"full"} text={"Loading..."} />;
    }

    return (
        <div className="immersion__my_interviews__result__content__question_card">
            <div className="immersion__my_interviews__result__content__question_card__header">
                <ResultGaugeChart score={score} />
            </div>
            {media && <PDFViewer signedUrl={media.url} scale={1} />}
        </div>
    );
};

export default ScanScoreCard;
